import Vuex from 'vuex'
import Vue from 'vue'
import HelpersRes from '@/helpers/Helpers.js';
// import moment from 'moment-timezone'
import hash from "object-hash"

Vue.use(Vuex)
//init store

var sortByIsPresent = function(rows) {
    let sortFunc = function compare(a, b) {
        if (a.isPresent > b.isPresent) return -1;
        if (b.isPresent > a.isPresent) return 1;
        return 0;
    }

    rows.sort(sortFunc)
};

var sortByName = function(rows) {
    let sortFunc = function compare(a, b) {
        // a.value = a.value.toLowerCase()
        // b.value = b.value.toLowerCase()
        if (a.value > b.value) return 1;
        if (b.value > a.value) return -1;
        return 0;
    }

    rows.sort(sortFunc)
};

var setFeaturesStates = function(features, rawFeatures) {
    var indx = 0
    var featuresRows = []

    features.forEach(f => {
        var featureRows = []
        if (!f.toRemove && (f.toAdd || f.isPresent)) {
            f.isPresent = true
            f.toAdd = false

            for (var i = 0; i < rawFeatures[indx].length; i++) {
                featureRows.push({
                    ...rawFeatures[indx][i],
                    isSelected: false,
                })
            }
            indx++
        } else {
            f.isPresent = false
            f.toRemove = false
            f.toAdd = false
        }
        sortByName(featureRows)
        featuresRows.push(featureRows)
        // if (!f.toRemove && (f.toAdd || f.isPresent)) {
        //     f.isPresent = true
        //     f.toAdd = false
        //     f.rows = rawFeatures[indx++]
        //     sortByName(f.rows)
        // } else {
        //     f.isPresent = false
        //     f.toRemove = false
        //     f.toAdd = false
        // }
    })

    return {
        features,
        featuresRows
    }
};

var setEventsStates = function(events) {
    events.forEach(e => {
        if (!e.toRemove && (e.toAdd || e.isPresent)) {
            e.isPresent = true
            e.toAdd = false
        } else {
            e.isPresent = false
            e.toRemove = false
            e.toAdd = false
        }
    })
    sortByIsPresent(events)

    return events
}

const store = new Vuex.Store({
    state: {
        metaIsPresent: false,
        availableFeatures: [],
        availableEvents: [],
        features: [],
        featuresRows: [],
        events: [],
        projects: [],
        sandbox: false,
        precision: "day",
        cohort: true,
        filter: {},
        selectedBundles: [],
        // maxDate: HelpersRes.maxDate(),
        // dateRanges: HelpersRes.dateRanges(),
        formulas: [],
        stateId: "",
        dates: {
            startDate: HelpersRes.dateRanges()["7 days"][0].toString(),
            endDate: HelpersRes.dateRanges()["7 days"][1].toString(),
            rangeLabel: "7 days",
        },
    },
    getters: {
        getHash(state) {
            var eventsPresent = []
            for (var i = 0; i < state.events.length; i++) {
                if (state.events[i].isPresent) {
                    eventsPresent.push(state.events[i].name)
                }
            }

            var featuresPresent = []
            for (var j = 0; j < state.features.length; j++) {
                if (state.features[j].isPresent) {
                    featuresPresent.push(state.features[j].name)
                }
            }

            var temp = {
                sandbox: state.sandbox,
                precision: state.precision,
                cohort: state.cohort,
                filter: state.filter,
                dates: state.dates,
                selectedBundles: state.selectedBundles,
                formulas: state.formulas,
                events: eventsPresent,
                features: featuresPresent
            }

            return hash(temp)
        }
    },
    mutations: {
        // refreshDates(state) {
        // state.maxDate = HelpersRes.maxDate()
        // state.dateRanges = HelpersRes.dateRanges()
        // },
        updateState(state, payload) {
            Object.keys(payload).forEach(key => {
                switch (key) {
                    case 'events':
                        state.events = HelpersRes.Normalize(state.availableEvents, payload.events)
                        break;
                    case 'features':
                        state.features = HelpersRes.Normalize(state.availableFeatures, ["bundle_id", ...payload.features])
                        break;
                    case 'data':
                        state.featuresRows = []
                        var {
                            features, featuresRows
                        } = setFeaturesStates(state.features, payload.data)
                        state.features = features
                        state.featuresRows = featuresRows
                        state.events = setEventsStates(state.events)
                        break;
                    case 'dates':
                        var dates = {}
                        // state.maxDate = HelpersRes.maxDate()
                        // state.dateRanges = HelpersRes.dateRanges()

                        dates.rangeLabel = payload.dates.rangeLabel
                        if (dates.rangeLabel != "Custom range") {
                            let dateRanges = HelpersRes.dateRanges()
                            dates.startDate = dateRanges[dates.rangeLabel][0].toString()
                            dates.endDate = dateRanges[dates.rangeLabel][1].toString()
                            // dates.startDate = state.dateRanges[dates.rangeLabel][0].toString()
                            // dates.endDate = state.dateRanges[dates.rangeLabel][1].toString()
                        } else {
                            dates.startDate = payload.dates.startDate
                            dates.endDate = payload.dates.endDate
                            dates.rangeLabel = "Custom range"
                        }
                        state.dates = dates
                        break;
                    default:
                        // Vue.set(state, [key], payload[key])
                        state[key] = payload[key]
                }
            });
        },
        setMeta(state, payload) {
            state.availableFeatures = ["bundle_id", ...payload.availableFeatures]
            state.features = HelpersRes.Normalize(state.availableFeatures, ["bundle_id", "source", "campaign", "geo"])
            state.events = HelpersRes.Normalize(payload.availableEvents, ["install", "subscription", "activation", "pay", "revenue"])
            state.availableEvents = payload.availableEvents
            state.projects = payload.projects
            state.selectedBundles = [payload.projects[0].bundleId]
            state.metaIsPresent = true
            state.formulas = [{
                    equation: "_revenue_/_install_",
                    name: "rev/inst$",
                },
                {
                    equation: "_revenue_/_subscription_",
                    name: "rev/sub$",
                },
                {
                    equation: "_pay_/_activation_",
                    name: "Δpay",
                },
                {
                    equation: "_subscription_/_install_*100",
                    name: "inst->sub%",
                },
                {
                    equation: "_activation_/_subscription_*100",
                    name: "sub->act%",
                },
            ]
        },
        alterFeature(state, id) {
            console.log("1");
            var f = state.features[id]
            if (f.isPresent) {
                f.toRemove = !f.toRemove
            } else {
                f.toAdd = !f.toAdd
            }
            console.log("2");
        },
        alterEvent(state, id) {
            var e = state.events[id]
            if (e.isPresent) {
                e.toRemove = !e.toRemove
            } else {
                e.toAdd = !e.toAdd
            }
        },
    }
})

export default store